import React, { useEffect, useState, useRef } from 'react';
// Assets
import Icon from 'assets/Icon';
// Styles
import styles from './style/salesOrderFilter.module.css';

interface EventFilterProps {
  children: React.ReactNode,
  label: string,
  value: string,
  required: boolean,
}

function SalesOrderFilter({ children, label, value, required }: EventFilterProps) {
  // State
  const [open, setOpen] = useState(false);
  // Refs
  const filter = useRef<HTMLDivElement>(null);

  // Handlers
  function handleClickOutside(e:MouseEvent) {
    if (e.target instanceof Element) {
      if (filter && filter.current && filter.current.contains(e.target)) {
        return;
      }
    }
    setOpen(false);
  }

  useEffect(() => {
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  return (
    <div
      className={`${styles.container} ${open && styles.container_open}`}
      ref={filter}
    >
      <div
        className={styles.toggle}
        onClick={() => setOpen(!open)}
        onKeyDown={() => setOpen(!open)}
        role="button"
        tabIndex={0}
      >
        <div>
          <h6 className="subtitle2">{ label } {required ? <span className={styles.red}>*</span> : ''}</h6>
          <span className={styles.toggle__value}>{ value && value.length > 0 ? value : 'Select' }</span>
        </div>
        <Icon icon="ExpandMore" />
      </div>
      <div className={styles.content}>
        { children }
      </div>
    </div>
  );
}

export default SalesOrderFilter;
